export function formatSyncTimestamp(value, locale) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(locale === 'fr' ? 'fr-FR' : 'en-GB', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
}

export function syncTimestampColumns(t, locale) {
  return [
    {
      key: 'createdAt',
      label: t('common.created_at'),
      render: (value) => <span className="text-slate-500 text-[12px] whitespace-nowrap">{formatSyncTimestamp(value, locale)}</span>,
    },
    {
      key: 'updatedAt',
      label: t('common.updated_at'),
      render: (value) => <span className="text-slate-500 text-[12px] whitespace-nowrap">{formatSyncTimestamp(value, locale)}</span>,
    },
  ];
}
